document.addEventListener("DOMContentLoaded", function () {

    // Function to process elements when they appear
   /* const processNewElements = (parent = document) => {
        parent.querySelectorAll(".boost-sd__product-image-column:not(.js-processed)").forEach(parentElement => {
            parentElement.classList.add("js-processed"); // Prevent duplicate processing
            console.log("Processing new .boost-sd__product-image-column");
    
            const firstButton = parentElement.querySelector("button");
    
            if (firstButton) {
                const clonedButton = firstButton.cloneNode(true);
                clonedButton.classList.add("js__add-to-cart");
                parentElement.appendChild(clonedButton);
            }
        });
    
        parent.querySelectorAll(".boost-sd__product-item:not(.js-processed)").forEach(product => {
            product.classList.add("js-processed");
    
            const productLink = product.querySelector(".boost-sd__product-link");
            const clonedButton = product.querySelector(".js__add-to-cart");
    
            if (productLink && clonedButton) {
                const href = productLink.getAttribute("href");
                const productHandle = href?.split("/products/")[1]?.split("?")[0];
    
                if (productHandle) {
                    clonedButton.setAttribute("data-product-handle", productHandle);
                }
            }
        });
    };
    
    // Function to observe the product list
    const observeBoostSdProductList = (boostSdRight) => {
        const observer = new MutationObserver(mutationsList => {
            mutationsList.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.matches(".boost-sd__product-list")) {
                        processNewElements(node);
                    }
                });
            });
        });
    
        observer.observe(boostSdRight, { childList: true, subtree: true });
    };
    
    
    const boostSdBlock = document.querySelector(".boost-sd__filter-block");
    // Check if the Boost Block exists
    if (boostSdBlock) {
        const observer = new MutationObserver(mutationsList => {
            mutationsList.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.matches(".boost-sd-container")) {
                        const boostSdRight = node.querySelector(".boost-sd-right");
                        if (boostSdRight) {
                            observeBoostSdProductList(boostSdRight);
                        }
                    }
                });
            });
        });
    
        observer.observe(boostSdBlock, { childList: true, subtree: true });
    } */
    
    
        document.body.addEventListener("click", function (event) {
            const button = event.target.closest(".js__add-to-cart");
            if (button) {
                event.preventDefault();
                event.stopPropagation();
    
                let productHandle = button.getAttribute("data-product-handle"); // Get the product handle
    
                if (productHandle) {
                    console.log(`Fetching product data from: /products/${productHandle}.json`);
                    fetch(`${productHandle}.json`)
                        .then(response => response.json())
                        .then(data => {
                            if (data.product && data.product.variants.length > 0) {
                                console.log("Product data:", data);
                                let defaultVariantId = data.product.variants[0].id; // Get the first variant ID
                                console.log("Default Variant ID:", defaultVariantId);
                                addToCart(defaultVariantId);
                            } else {
                                console.error("No variants found for product:", productHandle);
                            }
                        })
                        .catch(error => console.error("Error fetching product data:", error));
                }
            }
        });
    
        function addToCart(variantId) {
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log("Item added to cart", data);
                    if (!$(".cart-link__bubble").hasClass("cart-link__bubble--visible")) {
                        $(".cart-link__bubble").addClass("cart-link__bubble--visible");
                    }
                    var syncFee = window.MandatoryCartFee && window.MandatoryCartFee.sync;
                    if (syncFee) {
                        syncFee().then(function () {
                            openMiniCart();
                        });
                    } else {
                        openMiniCart();
                    }
                })
                .catch(error => console.error("Error adding item to cart", error));
        }
    });
   
   